export default __webpack_public_path__ + "static/media/skeletons.7325d80d.png";